if (!customElements.get('collection-promo-block')) {
	customElements.define(
		'collection-promo-block',
		class CollectionPromoBlock extends HTMLElement {
			constructor() {
				super();
				this.collectionTemplate = document.querySelector('.collection-main [data-section-id]');
				this.filters = this.querySelectorAll('[data-collection-filter]');
				if (this.filters.length === 0) return;
			}

			connectedCallback() {
				this.filters.forEach((item) => {
					item.addEventListener('click', (event) => {
						event.preventDefault();
						const url = item.href;
						this.changeCollectionMainContent(url);
						history.pushState({}, '', url);
					});
				});
			}

			changeCollectionMainContent(url) {
				fetch(url)
					.then((res) => res.text())
					.then((data) => {
						const html = new DOMParser().parseFromString(data, 'text/html');
						const destination = document.querySelector('.collection-main__grid-container');
						const source = html.querySelector('.collection-main__grid-container');
						const filterPopupDestination = document.querySelector('.collection-main__filter-popup');
						const filterPopupSource = html.querySelector('.collection-main__filter-popup');
						const collectionFaqDestination = document.querySelector('.colection-main__faq');
						const collectionFaqSource = html.querySelector('.colection-main__faq');
						if (source && destination) {
							destination.innerHTML = source.innerHTML;
						}

						if (filterPopupDestination && filterPopupSource) {
							filterPopupDestination.innerHTML = filterPopupSource.innerHTML;
						}

						if (collectionFaqDestination && collectionFaqSource) {
							collectionFaqDestination.innerHTML = collectionFaqSource.innerHTML;
						} else {
							if (collectionFaqDestination) {
								collectionFaqDestination.innerHTML = '';
							}
						}
					});
			}
		},
	);
}
